import React from 'react';
import {
  List,
  Datagrid,
  Responsive,
  TextInput,
  SimpleList,
  TopToolbar,
  Pagination
} from 'react-admin';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';
import Filter from '../../core/components/list/StyledFilter';
import ListTitleBar from '../../core/components/ListTitleBar';
import BulkActionDeleteButton from '../../core/components/BulkActionDeleteButton';
import { makeStyles } from '@material-ui/core';
import Empty from '../../core/components/list/Empty';
import DistributionListIcon from '@material-ui/icons/Subject';
import LinkField from '../../core/components/LinkField';

const useStyles = makeStyles({
  textInput: {
    minWidth: '225px'
  },
  dataGridHead: {
    '& tr': {
      '& th:nth-of-type(1)': {
        width: '24px'
      }
    }
  },
  root: {
    marginRight: 'auto'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();

  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const DistributionListFilter = props => {
  const classes = useStyles();

  return (
    <Filter variant="standard" {...props}>
      <TextInput
        label="Search by Distribution List Name"
        source="name"
        alwaysOn
        className={classes.textInput}
        parse={predictiveSearchParser}
        format={predictiveSearchFormatter}
        options={{ autoComplete: 'off' }}
      />
    </Filter>
  );
};

const DistributionListTitle = props => {
  return (
    <ListTitleBar
      type="Distribution Lists"
      title="New Distribution List"
      createUrl="#/distributionlists/create"
      icon={<DistributionListIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

const DistributionListList = props => {
  const classes = useStyles();
  const {
    hasDeletePermission,
    hasCreatePermission,
    hasEditPermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      sort={{ field: 'name', order: 'ASC' }}
      title={
        <DistributionListTitle hasCreatePermission={hasCreatePermission} />
      }
      exporter={false}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      filters={<DistributionListFilter />}
      bulkActionButtons={hasDeletePermission && <BulkActionDeleteButton />}
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.name}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid
            classes={{ thead: hasDeletePermission && classes.dataGridHead }}
          >
            <LinkField
              label="Distribution List Name"
              source="name"
              linkType="show"
            />
          </Datagrid>
        }
      />
    </List>
  );
};

export default DistributionListList;
